import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { AbstractEditActionButton } from '@connect-services/client/components/abstract-edit-action-button/abstract-edit-action-button.component';
import { StackIconsComponent } from '@connect-services/client/components/stack-icons/stack-icons.component';
import { RessourcesModule } from '@ressources/client/ressources.module';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RessourcesModule, StackIconsComponent],
    selector: 'app-geographic-edit-button',
    templateUrl: './geographic-edit-button.component.html',
})
export class GeographicEditButtonComponent extends AbstractEditActionButton {
    public readonly customTooltip = input<string | undefined>();
    public readonly isActive = input<boolean>(false);

    protected resolveTooltip(): string | null {
        const tooltip: string | undefined = this.customTooltip();
        if (tooltip) {
            return tooltip;
        }

        if (!this.hasPermission()) {
            return 'insufficientPermissions';
        }

        if (!this.isEditable()) {
            return 'editMode.layerStandardNotEditable';
        }

        return this.layerEditConfig()?.geographicEditTooltipKey ?? null;
    }
}
